(function() {
	'use strict';

	angular
		.module('app.core', ['ui.bootstrap', 'pascalprecht.translate',
			'smart-table', 'angularutilities', 'smarttableutilities',
			'ngSha'
		]);
})();
